import { render, staticRenderFns } from "./LightboxNav.vue?vue&type=template&id=474b067f&scoped=true&"
var script = {}
import style0 from "./LightboxNav.vue?vue&type=style&index=0&id=474b067f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b067f",
  null
  
)

export default component.exports